import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../store' // Assuming your RootState is defined in the store
import { useGlobalLoadingActions } from '@hooks/useGlobalLoading'

const AUTH_VERIFICATION_LOADING_CONTAINER = 'body'

const ProtectedRoute = (): React.ReactElement => {
  const isAuth = useSelector((state: RootState) => state.auth.isAuthenticated)
  const isVerifyingToken = useSelector(
    (state: RootState) => state.auth.isVerifyingToken,
  )
  const location = useLocation()
  const { showLoading, hideLoading } = useGlobalLoadingActions()

  useEffect(() => {
    if (isVerifyingToken) {
      showLoading({ container: AUTH_VERIFICATION_LOADING_CONTAINER })
    } else {
      hideLoading(AUTH_VERIFICATION_LOADING_CONTAINER)
    }
    return () => hideLoading(AUTH_VERIFICATION_LOADING_CONTAINER)
  }, [isVerifyingToken, showLoading, hideLoading])

  if (isVerifyingToken) {
    return <></>
  }

  return isAuth ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location.pathname }} replace />
  )
}

export default ProtectedRoute
